import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback } from 'react';
import styles from './styles.module.css';
export const HiddenTabButton = forwardRef(({ listRef, tabIndex }, ref) => {
    const handleFocus = useCallback((e) => {
        var _a;
        if (e.relatedTarget !== listRef.current) {
            (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        e.preventDefault();
        e.stopPropagation();
    }, [listRef]);
    const handleKeyDown = useCallback((e) => {
        e.stopPropagation();
    }, []);
    return (_jsx("button", { type: 'button', "aria-hidden": true, ref: ref, onKeyDown: handleKeyDown, onFocus: handleFocus, className: styles.hiddenBtn, tabIndex: tabIndex }));
});
